<template>
  <b-card class="dashboard-bcard mb-1">
    <div class="d-flex align-items-center mb-2">
      <feather-icon
        icon="BarChart2Icon"
        size="30"
        class="mr-1 text-dark"
      />
      <span class="card-title mb-0">Ventas vs Meta por Vendedor</span>
    </div>
    <div
      v-if="loading"
      class="dashboard-loader"
    >
      <b-spinner
        variant="primary"
        label="Cargando..."
      />
      <span class="loader-text">Cargando datos de ventas...</span>
    </div>
    <div
      v-else
      class="dashboard-bar-chart"
    >
      <canvas
        ref="barChart"
        height="320"
      />
    </div>
  </b-card>
</template>

<script>
import Chart from 'chart.js'

export default {
  name: 'DashboardBarChart',
  props: {
    salesData: {
      type: Array,
      default: () => [],
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      chartInstance: null,
    }
  },
  watch: {
    salesData: {
      handler() {
        if (!this.loading) {
          this.renderChart()
        }
      },
      deep: true,
    },
    loading(newVal) {
      if (!newVal && this.salesData.length > 0) {
        this.$nextTick(() => {
          this.renderChart()
        })
      }
    },
  },
  mounted() {
    if (!this.loading) {
      this.renderChart()
    }
  },
  methods: {
    renderChart() {
      if (!Chart || !this.$refs.barChart) return
      if (this.chartInstance) this.chartInstance.destroy()
      const labels = this.salesData.map(u => u.user_name)
      const sales = this.salesData.map(u => u.total_sales)
      const targets = this.salesData.map(u => u.sales_target)
      this.chartInstance = new Chart(this.$refs.barChart.getContext('2d'), {
        type: 'bar',
        data: {
          labels,
          datasets: [
            {
              label: 'Ventas (Q)',
              data: sales,
              backgroundColor: '#42a5f5',
            },
            {
              label: 'Meta (Q)',
              data: targets,
              backgroundColor: '#66bb6a',
            },
          ],
        },
        options: {
          responsive: true,
          maintainAspectRatio: false,
          legend: { position: 'top' },
          title: { display: false },
          scales: {
            yAxes: [{
              ticks: {
                beginAtZero: true,
                callback: value => `Q${Number(value).toLocaleString()}`,
              },
            }],
          },
        },
      })
    },
  },
}
</script>

<style scoped>
.dashboard-bcard {
  min-height: 120px;
  padding: 1.2rem 1.5rem;
  box-shadow: 0 2px 8px rgba(0,0,0,0.04);
  border-radius: 12px;
}
.card-title {
  font-size: 1.25rem;
  font-weight: 600;
  color: #222;
}
.dashboard-loader {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 320px;
  gap: 1rem;
}
.loader-text {
  font-size: 0.9rem;
  color: #666;
  font-weight: 500;
}
.dashboard-bar-chart {
  background: #fff;
  border-radius: 12px;
  padding: 0;
  margin-bottom: 0;
  max-width: 100%;
  min-height: 320px;
  height: 320px;
  display: flex;
  align-items: center;
  justify-content: center;
}
canvas {
  max-width: 100% !important;
  width: 100% !important;
  height: 320px !important;
  min-height: 220px;
  display: block;
}
</style>
